import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    scopeFilter: {
      marginLeft: theme.spacing(2),
    },
    deleteIcon: {
      width: 16,
      height: 16,
      background: ' #14171A',
      color: '#fff',
      borderRadius: '50%',

      '&:hover': {
        color: '#fff',
      },
    },
    chipAdd: {
      margin: theme.spacing(0.5),
      marginBottom: 10,
      fontSize: 14,
      fontWeight: 550,
      border: ' 2px dashed #14171A !important',
      '& span': {
        color: '#14171A',
      },
      cursor: 'pointer',
    },
    chipLabel: {
      fontSize: theme.spacing(2),
      fontWeight: 500,
      color: theme.palette.colors.blue,
    },
    chipRoot: {
      minWidth: 150,
      justifyContent: 'space-between',
    },
    paperRoot: {
      marginTop: 32,
      paddingBottom: theme.spacing(2),
    },
    gridContainer: {
      padding: '0px 16px',
    },
    chipContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      paddingTop: 0,
    },
    chip: {
      margin: theme.spacing(0.5),
      marginBottom: 10,
      fontSize: 14,
      fontWeight: 550,
    },
    paperTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    addButton: {
      background: '#0094FF',
      borderRadius: 12,
      color: '#fff',
      minHeight: 40,
      padding: '0px 16px',
      '&:hover': {
        background: '#0094FF',
        filter: 'brightness(0.9)',
      },
    },
  }),
);

export default useStyles;
